import { DefaultState, IState } from "./state";
import { Keys, Types } from "./actions/types";
import { infos } from "../../../model/infos";
// import { actionCreator as notificationActions, IActions as INotificationAction } from '../notification/actions/creators'

export const reducer = (state: IState = DefaultState(), action: Types): IState => {
    switch (action.type) {
        case Keys.LOADINFOS_PENDING: {
            return {
                ...state,
                informations: [],
                isLoadingInfos: true,
            }
        }
        case Keys.LOADINFOS_FULFILLED: {
            let p: Array<infos> = action.payload;
            return {
                ...state,
                informations: p,
                isLoadingInfos: false,
            }
        }
        case Keys.LOADINFOS_REJECTED: {
            return {
                ...state,
                informations: [],
                isLoadingInfos: false,
            }
        }
        case Keys.SAVEINFOS_PENDING: {
            return state;
        }
        case Keys.SAVEINFOS_FULFILLED: {
            let saved: infos = action.payload;

            let infos = [...state.informations];
            let found = infos.findIndex(c => c._id === saved._id);
            if (found >= 0) {
                infos[found] = saved;
            }
            else {
                infos.push(saved);
            }

            // import { actionCreator as notificationActions, IActions as INotificationAction } from '../../notification/actions/creators'
            // .then(resp => {
            //     console.log("saveInfos", "setSaveNotification", resp);
            //     notificationActions
            // })
            // notificationActions.di
            // setSaveNotification(true);

            return {
                ...state,
                informations: infos,
                isLoadingInfos: false,
            }
        }
        case Keys.SAVEINFOS_REJECTED: {
            return state;
        }
        case Keys.DELETEINFOS_PENDING: {
            return state;
        }
        case Keys.DELETEINFOS_FULFILLED: {
            let saved: { id: string, deleted: boolean } = action.payload;

            let infos = [...state.informations];
            if (saved.deleted) {
                let found = infos.findIndex(c => c._id === saved.id);
                if (found >= 0) {
                    infos.splice(found, 1);
                }
            }

            return {
                ...state,
                informations: infos,
                isLoadingInfos: false,
            }
        }
        default:
            return state;
    }
}